import React from 'react';
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import poolIcon from '../../assets/images/coin/pool.png' 
import referralIcon from '../../assets/images/coin/referral.png' 
import oscarIcon from '../../assets/images/icon/OSCAR_LOGO.png'
import comparisonImg from '../../assets/images/icon/Comparison-logo.png' 
import Skeleton from '@mui/material/Skeleton';

import { Link } from 'react-router-dom';


function Banner({ stakeData }) { 
    return (
        <section className="crypto" data-aos="fade-up" data-aos-duration="1000" style={{ marginTop: 20 }}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="crypto__main">
                            <Tabs>
                                <TabPanel>
                                    <div className="content-inner">
                                        {/* Rewards Pool */}
                                        <div className="crypto-box active">
                                            <div className="top">
                                                {stakeData ? (
                                                    <Link to="#">
                                                        <img
                                                            src={poolIcon}
                                                            alt="rockie"
                                                            style={{ width: 30, height: 30 }}
                                                        />
                                                        <span>Rewards Pool</span>
                                                        <span className="unit"></span>
                                                    </Link>
                                                ) : (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <Skeleton variant="circular" width={22} height={22} />
                                                        <Skeleton style={{ width: 180, height: 25 }} />
                                                    </div>

                                                )}
                                            </div>
                                            {stakeData ? (
                                                <>
                                                    <h6 className="price">{stakeData ? stakeData.hopeRemainingBalance : 0} OSCAR</h6>
                                                    <div className="bottom">
                                                        <p>Allocated:</p>
                                                        <p>&nbsp;&nbsp;{stakeData ? stakeData.hopeAllocated : 0} OSCAR</p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>
                                                        <p>Remaining:</p>
                                                        <p className="sale success" style={{backgroundColor: '#119f24'}}>{stakeData ? stakeData.hopeRemainingBalance : 0} OSCAR</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <h6 className="price"> <Skeleton style={{ width: 120, height: 30 }} /> </h6>
                                                    <div className="bottom">
                                                        <p> <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>

                                                        <p  > <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Estimated Rewards */}
                                        <div className="crypto-box active">
                                            <div className="top">
                                                {stakeData ? (
                                                    <Link to="#">
                                                        <img
                                                            src={comparisonImg}
                                                            alt="rockie"
                                                            style={{ width: 30, height: 30 }}
                                                        />
                                                        <span>Estimated Rewards</span>
                                                        <span className="unit"></span>
                                                    </Link>
                                                ) : (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <Skeleton variant="circular" width={22} height={22} />
                                                        <Skeleton style={{ width: 180, height: 25 }} />
                                                    </div>
                                                )}
                                            </div>


                                            {stakeData ? (
                                                <>
                                                    <h6 className="price">{stakeData ? stakeData.apy : 0}% APY</h6>
                                                    <div className="bottom">
                                                        <p>Epoch duration:</p>
                                                        <p>&nbsp;&nbsp;{stakeData ? stakeData.rewardEpochDuration : 0} hours</p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>
                                                        <p>Epoch Reward Rate:</p>
                                                        <p className="sale success" style={{backgroundColor: "#119f24"}}>{stakeData ? stakeData.rewardRatePerEpoch : 0} OSCAR</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <h6 className="price"> <Skeleton style={{ width: 120, height: 30 }} /> </h6>
                                                    <div className="bottom">
                                                        <p> <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>

                                                        <p  > <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Referral Bonus */}
                                        <div className="crypto-box active">
                                            <div className="top">

                                                {stakeData ? (
                                                    <Link to="#">
                                                        <img
                                                            src={referralIcon}
                                                            alt="rockie"
                                                            style={{ width: 30, height: 30 }}
                                                        />
                                                        <span>Referral Bonus</span>
                                                        <span className="unit"></span>
                                                    </Link>
                                                ) : (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <Skeleton variant="circular" width={22} height={22} />
                                                        <Skeleton style={{ width: 180, height: 25 }} />
                                                    </div>
                                                )}
                                            </div>
                                            {stakeData ? (
                                                <>
                                                    <h6 className="price">{stakeData ? stakeData.referralRewardRate : 0}% Bonus</h6>
                                                    <div className="bottom">
                                                        <p>Rewards:</p>
                                                        <p>&nbsp;&nbsp;credited instantly</p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>
                                                        <p>Max Bonus Per Referral:</p>
                                                        <p className="sale success" style={{backgroundColor: "#119f24"}}>{stakeData ? stakeData.maxBonusAmount : 0} OSCAR</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <h6 className="price"> <Skeleton style={{ width: 120, height: 30 }} /> </h6>
                                                    <div className="bottom">
                                                        <p> <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>

                                                        <p  > <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Total Staked */}
                                        <div className="crypto-box active">
                                            <div className="top">
                                                {stakeData ? (
                                                    <Link to="#">
                                                        <img
                                                            src={oscarIcon}
                                                            alt="rockie"
                                                            style={{ width: 30, height: 30 }}
                                                        />
                                                        <span>Total Staked</span>
                                                        <span className="unit"></span>
                                                    </Link>
                                                ) : (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <Skeleton variant="circular" width={22} height={22} />
                                                        <Skeleton style={{ width: 180, height: 25 }} />
                                                    </div>
                                                )}
                                            </div>

                                            {stakeData ? (
                                                <>
                                                    <h6 className="price">{stakeData ? stakeData.totalStakedAmount : 0} OSCAR</h6>
                                                    <div className="bottom">
                                                        <p>Total stakers:</p>
                                                        <p>&nbsp;&nbsp;{stakeData ? stakeData.totalStakers : 0}</p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>
                                                        <p>Total Claimed:</p>
                                                        <p className="sale success" style={{backgroundColor: "#119f24"}}>{stakeData ? stakeData.totalClaimedAmount : 0} OSCAR</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <h6 className="price"> <Skeleton style={{ width: 120, height: 30 }} /> </h6>
                                                    <div className="bottom">
                                                        <p> <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                    <div className="bottom" style={{ marginTop: 5 }}>

                                                        <p  > <Skeleton style={{ width: 220, height: 25 }} /></p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner;